// extracted by mini-css-extract-plugin
export var Darkbg = "Footer-module--Darkbg--oqTrK";
export var content = "Footer-module--content--A1dSL";
export var fadeBackground = "Footer-module--fadeBackground--YvK4m";
export var fadeBodyDark = "Footer-module--fadeBodyDark--0aV78";
export var fadeBodyLight = "Footer-module--fadeBodyLight--yd5uq";
export var footer = "Footer-module--footer--LZE0a";
export var footerDark = "Footer-module--footerDark--FR+T-";
export var footerLight = "Footer-module--footerLight--KhBOw";
export var limitWidthOnLargeScreens = "Footer-module--limitWidthOnLargeScreens--Cootf";